import React, { useEffect, useState } from 'react';
import css from '../../../../styles/modules/PaymentSummary/infocard.module.css';

export default function FromToCircle({ client, tenant, type, tenantLogo }) {
  //if the transaction is a disbursement then the image is on first postion in the cirlces
  //else the initals are on first pos.

  function returnCorrectOrder() {
    if (type?.toLowerCase() === 'client disbursement') {
      return (
        <div className={css.fromTo}>
          <div className={css.circleWrapper}>
            <img className={css.tenantLogoInCircle} src={tenantLogo} />
          </div>
          <div className={css.arrowContainer}>
            <div className={css.arrowLine}></div>
            <div className={css.arrowTip}></div>
          </div>
          <div className={css.circleWrapper}>
            <p className={css.initials}>
              {client?.firstName && client?.lastName
                ? client.firstName[0].toUpperCase() +
                  client.lastName[0].toUpperCase()
                : 'N/A'}
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div className={css.fromTo}>
          <div className={css.circleWrapper}>
            <p className={css.initials}>
              {client?.firstName && client?.lastName
                ? client.firstName[0].toUpperCase() +
                  client.lastName[0].toUpperCase()
                : 'N/A'}
            </p>
          </div>
          <div className={css.arrowContainer}>
            <div className={css.arrowLine}></div>
            <div className={css.arrowTip}></div>
          </div>
          <div className={css.circleWrapper}>
            <img className={css.tenantLogoInCircle} src={tenantLogo} />
          </div>
        </div>
      );
    }
  }

  return returnCorrectOrder();
}
